import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MarkdownContent } from '@/components/MarkdownContent.js';
import termsMarkdown from '@/content/terms.md?raw';
import privacyMarkdown from '@/content/privacy-policy.md?raw';

type LegalPageProps = {
  kind: 'terms' | 'privacy';
};

export function LegalPage({ kind }: LegalPageProps) {
  const { t } = useTranslation('legal');

  const title = kind === 'terms' ? t('terms.title') : t('privacy.title');
  const markdown = kind === 'terms' ? termsMarkdown : privacyMarkdown;
  const lastUpdated = '2026年3月16日';

  return (
    <main
      className="min-h-screen px-5 py-8 sm:px-8 sm:py-12"
      style={{ backgroundColor: 'var(--color-bg-app)' }}
    >
      <div className="mx-auto w-full max-w-[720px]">
        <article
          className="rounded-2xl p-6 sm:p-10"
          style={{
            backgroundColor: 'var(--color-bg-surface)',
            border: '1px solid var(--color-border)',
            boxShadow: 'var(--shadow-lg)',
          }}
        >
          <header
            className="mb-6 pb-5"
            style={{ borderBottom: '1px solid var(--color-border)' }}
          >
            <Link
              to="/"
              className="text-[13px] font-medium hover:opacity-80 transition-opacity"
              style={{ color: 'var(--color-accent)' }}
            >
              Timeline
            </Link>
            <p
              className="mt-2 text-[13px]"
              style={{ color: 'var(--color-text-tertiary)' }}
            >
              {t('lastUpdated', { date: lastUpdated })}
            </p>
          </header>

          <div className="max-w-none">
            <MarkdownContent markdown={markdown} />
          </div>
        </article>
      </div>
    </main>
  );
}
